export interface ResetPasswordValues {
  password: string
  passwordConfirmation: string
}

export const resetPasswordValuesDefault: ResetPasswordValues = {
  password: '',
  passwordConfirmation: '',
}
